export const ROLE_ADMIN = 'admin'
export const ROLE_OWNER = 'owner'
export const ROLE_MANAGER = 'manager'

export type AppRole = typeof ROLE_ADMIN | typeof ROLE_OWNER | typeof ROLE_MANAGER | string
export type PermissionResource =
  | 'companies'
  | 'properties'
  | 'requests'
  | 'bookings'
  | 'guests'
  | 'contacts'
  | 'screens'
  | 'announcements'
  | 'users'
  | 'billing'
  | 'email_settings'
export type PermissionAction = 'view' | 'add' | 'edit' | 'delete'

const PERMISSION_MATRIX: Record<PermissionResource, Record<PermissionAction, AppRole[]>> = {
  companies: {
    view: [ROLE_ADMIN, ROLE_OWNER, ROLE_MANAGER],
    add: [ROLE_ADMIN],
    edit: [ROLE_ADMIN, ROLE_OWNER],
    delete: [ROLE_ADMIN],
  },
  properties: {
    view: [ROLE_ADMIN, ROLE_OWNER, ROLE_MANAGER],
    add: [ROLE_ADMIN, ROLE_OWNER, ROLE_MANAGER],
    edit: [ROLE_ADMIN, ROLE_OWNER, ROLE_MANAGER],
    delete: [ROLE_ADMIN, ROLE_OWNER, ROLE_MANAGER],
  },
  requests: {
    view: [ROLE_ADMIN, ROLE_OWNER, ROLE_MANAGER],
    add: [ROLE_ADMIN, ROLE_OWNER, ROLE_MANAGER],
    edit: [ROLE_ADMIN, ROLE_OWNER, ROLE_MANAGER],
    delete: [ROLE_ADMIN, ROLE_OWNER],
  },
  bookings: {
    view: [ROLE_ADMIN, ROLE_OWNER, ROLE_MANAGER],
    add: [ROLE_ADMIN, ROLE_OWNER, ROLE_MANAGER],
    edit: [ROLE_ADMIN, ROLE_OWNER, ROLE_MANAGER],
    delete: [ROLE_ADMIN, ROLE_OWNER, ROLE_MANAGER],
  },
  guests: {
    view: [ROLE_ADMIN, ROLE_OWNER, ROLE_MANAGER],
    add: [ROLE_ADMIN, ROLE_OWNER, ROLE_MANAGER],
    edit: [ROLE_ADMIN, ROLE_OWNER, ROLE_MANAGER],
    delete: [ROLE_ADMIN, ROLE_OWNER, ROLE_MANAGER],
  },
  contacts: {
    view: [ROLE_ADMIN],
    add: [ROLE_ADMIN],
    edit: [ROLE_ADMIN],
    delete: [ROLE_ADMIN],
  },
  screens: {
    view: [ROLE_ADMIN, ROLE_OWNER, ROLE_MANAGER],
    add: [ROLE_ADMIN, ROLE_OWNER, ROLE_MANAGER],
    edit: [ROLE_ADMIN, ROLE_OWNER, ROLE_MANAGER],
    delete: [ROLE_ADMIN, ROLE_OWNER],
  },
  announcements: {
    view: [ROLE_ADMIN, ROLE_OWNER, ROLE_MANAGER],
    add: [ROLE_ADMIN, ROLE_OWNER, ROLE_MANAGER],
    edit: [ROLE_ADMIN, ROLE_OWNER, ROLE_MANAGER],
    delete: [ROLE_ADMIN, ROLE_OWNER],
  },
  users: {
    view: [ROLE_ADMIN],
    add: [ROLE_ADMIN],
    edit: [ROLE_ADMIN],
    delete: [ROLE_ADMIN],
  },
  billing: {
    view: [ROLE_ADMIN],
    add: [ROLE_ADMIN],
    edit: [ROLE_ADMIN],
    delete: [ROLE_ADMIN],
  },
  email_settings: {
    view: [ROLE_ADMIN],
    add: [ROLE_ADMIN],
    edit: [ROLE_ADMIN],
    delete: [ROLE_ADMIN],
  },
}

export function canRole(
  role: AppRole | undefined,
  resource: PermissionResource,
  action: PermissionAction,
): boolean {
  if (!role) {
    return false
  }

  return PERMISSION_MATRIX[resource][action].includes(role)
}
